import { render, staticRenderFns } from "./DataListHeaderWithIcons.vue?vue&type=template&id=a6880fe6&scoped=true&"
import script from "./DataListHeaderWithIcons.vue?vue&type=script&lang=js&"
export * from "./DataListHeaderWithIcons.vue?vue&type=script&lang=js&"
import style0 from "./DataListHeaderWithIcons.vue?vue&type=style&index=0&id=a6880fe6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6880fe6",
  null
  
)

export default component.exports